// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4R9jnl","center":"G4_6y7"};